// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
    margin: 0;
    font-family: Arial, sans-serif;
    background-color: #121212;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  } */
    .spinner {
      border: 4px solid rgba(242, 234, 234, 0.3); /* Light border */
      border-top: 4px solid #e28a32; /* White border */
      border-radius: 50%;
      width: 40px;
      height: 40px;
      animation: spin 1s linear infinite; /* Infinite spinning */
  }

  @keyframes spin {
      0% {
          transform: rotate(0deg);
      }
      100% {
          transform: rotate(360deg);
      }
  }

  @keyframes pulse-green {
      0% {
          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(20, 174, 92, 0.7);
      }
      70% {
          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 10px rgba(20, 174, 92, 0);
      }
      100% {
          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(20, 174, 92, 0);
      }
  }

  @keyframes pulse-red {
      0% {
          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(236, 34, 31, 0.7);
      }
      70% {
          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 10px rgba(236, 34, 31, 0);
      }
      100% {
          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(236, 34, 31, 0);
      }
  }
  .chat-container {
    height: 300px; /* Adjust based on your popup size */
    width: 100%; /* Full width on mobile */
    max-width: 400px; /* Max width on larger screens */
    overflow-y: auto; /* Enables scrolling */
    overflow-x: hidden; /* Prevents horizontal scrolling */
    background-color: #1e1e1e; /* Dark theme */
    padding: 10px;
    border-radius: 8px;
    color: white;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    margin: 0 auto; /* Center the container */
  }
  
  .chat-bubble {
    margin: 10px 0;
    padding: 10px 15px;
    border-radius: 12px;
    max-width: 75%; /* Adjust to fit in the popup */
    word-wrap: break-word;
  }
  
  .chat-bubble.agent {
    background-color: #2a9d8f;
    color: #fff;
    align-self: flex-start;
  }
  
  .chat-bubble.user {
    background-color: #264653;
    color: #fff;
    align-self: flex-end;
  }
  
  /* Media Query for mobile devices */
  @media (max-width: 600px) {
    .chat-container {
      width: 90%; /* Adjust width for mobile */
      max-width: none; /* Remove max width */
      height: 250px; /* Reduce height for smaller screens */
    }
  
    .chat-bubble {
      max-width: 90%; /* Allow bubbles to take more width on mobile */
    }
  }
  


#root {
    max-width: 1280px;
    margin: 0 auto;
    padding: 2rem;
    text-align: center;
  }
  
  .logo {
    height: 6em;
    padding: 1.5em;
    will-change: filter;
    transition: filter 300ms;
  }
  .logo:hover {
    filter: drop-shadow(0 0 2em #646cffaa);
  }
  .logo.react:hover {
    filter: drop-shadow(0 0 2em #61dafbaa);
  }
  
  @keyframes logo-spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  
  @media (prefers-reduced-motion: no-preference) {
    a:nth-of-type(2) .logo {
      animation: logo-spin infinite 20s linear;
    }
  }
  
  .card {
    padding: 2em;
  }
  
  .read-the-docs {
    color: #888;
  }
  

/* widget */

.chat-widget {
  display: flex;
  align-items: center;
  background-color: #002F86;
  color: white;
  padding: 12px 24px;
  border-radius:16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  font-family: 'Orbitron', sans-serif;
  gap: 1px;
  width: fit-content;
}

.chat-logo {
  width: 50px;  /* Adjusted width */
  height: 50px;  /* Adjusted height */
  border-radius: 50%;  /* Make it a circle */
  overflow: hidden;  /* Ensures the image is clipped to fit the circle */
}

.chat-logo-img {
  width: 100%;  /* Make the image responsive within the container */
  height: 100%;
  object-fit: cover;  /* Ensures the image covers the div while maintaining aspect ratio */
}

.chat-text {
  /* display: flex; */
  flex-direction: column;
  color: white !important;
  /* text-align: left; */
}
.chat-text-header{
   text-align: center !important;
   color: white !important;
}

.chat-text p {
  color: white !important;
  margin: 0;
  font-size: 12px;
  /* font-weight: bold; */
}

.underline {
  display: inline-block;
  width: 80px;
  border-bottom: 2px solid white;
  margin-left: 5px;
}

.chat-powered {
  font-size: 2px;
  color: white;
  padding-left:38px;
}`, "",{"version":3,"sources":["webpack://./src/app.css"],"names":[],"mappings":"AAEA;;;;;;;;;KASK;IACD;MACE,0CAA0C,EAAE,iBAAiB;MAC7D,6BAA6B,EAAE,iBAAiB;MAChD,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,kCAAkC,EAAE,sBAAsB;EAC9D;;EAEA;MACI;UACI,uBAAuB;MAC3B;MACA;UACI,yBAAyB;MAC7B;EACJ;;EAEA;MACI;UACI,uEAAuE;MAC3E;MACA;UACI,wEAAwE;MAC5E;MACA;UACI,qEAAqE;MACzE;EACJ;;EAEA;MACI;UACI,uEAAuE;MAC3E;MACA;UACI,wEAAwE;MAC5E;MACA;UACI,qEAAqE;MACzE;EACJ;EACA;IACE,aAAa,EAAE,oCAAoC;IACnD,WAAW,EAAE,yBAAyB;IACtC,gBAAgB,EAAE,gCAAgC;IAClD,gBAAgB,EAAE,sBAAsB;IACxC,kBAAkB,EAAE,kCAAkC;IACtD,yBAAyB,EAAE,eAAe;IAC1C,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,cAAc,EAAE,yBAAyB;EAC3C;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,cAAc,EAAE,+BAA+B;IAC/C,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,oBAAoB;EACtB;;EAEA,mCAAmC;EACnC;IACE;MACE,UAAU,EAAE,4BAA4B;MACxC,eAAe,EAAE,qBAAqB;MACtC,aAAa,EAAE,sCAAsC;IACvD;;IAEA;MACE,cAAc,EAAE,+CAA+C;IACjE;EACF;;;;AAIF;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,wBAAwB;EAC1B;EACA;IACE,sCAAsC;EACxC;EACA;IACE,sCAAsC;EACxC;;EAEA;IACE;MACE,uBAAuB;IACzB;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE;MACE,wCAAwC;IAC1C;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;;AAGF,WAAW;;AAEX;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,wCAAwC;EACxC,mCAAmC;EACnC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW,GAAG,mBAAmB;EACjC,YAAY,GAAG,oBAAoB;EACnC,kBAAkB,GAAG,qBAAqB;EAC1C,gBAAgB,GAAG,mDAAmD;AACxE;;AAEA;EACE,WAAW,GAAG,mDAAmD;EACjE,YAAY;EACZ,iBAAiB,GAAG,oEAAoE;AAC1F;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;GACG,6BAA6B;GAC7B,uBAAuB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Orbitron:wght@400;700&display=swap');\n\n/* body {\n    margin: 0;\n    font-family: Arial, sans-serif;\n    background-color: #121212;\n    color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 100vh;\n  } */\n    .spinner {\n      border: 4px solid rgba(242, 234, 234, 0.3); /* Light border */\n      border-top: 4px solid #e28a32; /* White border */\n      border-radius: 50%;\n      width: 40px;\n      height: 40px;\n      animation: spin 1s linear infinite; /* Infinite spinning */\n  }\n\n  @keyframes spin {\n      0% {\n          transform: rotate(0deg);\n      }\n      100% {\n          transform: rotate(360deg);\n      }\n  }\n\n  @keyframes pulse-green {\n      0% {\n          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(20, 174, 92, 0.7);\n      }\n      70% {\n          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 10px rgba(20, 174, 92, 0);\n      }\n      100% {\n          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(20, 174, 92, 0);\n      }\n  }\n\n  @keyframes pulse-red {\n      0% {\n          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(236, 34, 31, 0.7);\n      }\n      70% {\n          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 10px rgba(236, 34, 31, 0);\n      }\n      100% {\n          box-shadow: 0 8px 32px rgba(0,0,0,0.25), 0 0 0 0 rgba(236, 34, 31, 0);\n      }\n  }\n  .chat-container {\n    height: 300px; /* Adjust based on your popup size */\n    width: 100%; /* Full width on mobile */\n    max-width: 400px; /* Max width on larger screens */\n    overflow-y: auto; /* Enables scrolling */\n    overflow-x: hidden; /* Prevents horizontal scrolling */\n    background-color: #1e1e1e; /* Dark theme */\n    padding: 10px;\n    border-radius: 8px;\n    color: white;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n    margin: 0 auto; /* Center the container */\n  }\n  \n  .chat-bubble {\n    margin: 10px 0;\n    padding: 10px 15px;\n    border-radius: 12px;\n    max-width: 75%; /* Adjust to fit in the popup */\n    word-wrap: break-word;\n  }\n  \n  .chat-bubble.agent {\n    background-color: #2a9d8f;\n    color: #fff;\n    align-self: flex-start;\n  }\n  \n  .chat-bubble.user {\n    background-color: #264653;\n    color: #fff;\n    align-self: flex-end;\n  }\n  \n  /* Media Query for mobile devices */\n  @media (max-width: 600px) {\n    .chat-container {\n      width: 90%; /* Adjust width for mobile */\n      max-width: none; /* Remove max width */\n      height: 250px; /* Reduce height for smaller screens */\n    }\n  \n    .chat-bubble {\n      max-width: 90%; /* Allow bubbles to take more width on mobile */\n    }\n  }\n  \n\n\n#root {\n    max-width: 1280px;\n    margin: 0 auto;\n    padding: 2rem;\n    text-align: center;\n  }\n  \n  .logo {\n    height: 6em;\n    padding: 1.5em;\n    will-change: filter;\n    transition: filter 300ms;\n  }\n  .logo:hover {\n    filter: drop-shadow(0 0 2em #646cffaa);\n  }\n  .logo.react:hover {\n    filter: drop-shadow(0 0 2em #61dafbaa);\n  }\n  \n  @keyframes logo-spin {\n    from {\n      transform: rotate(0deg);\n    }\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  @media (prefers-reduced-motion: no-preference) {\n    a:nth-of-type(2) .logo {\n      animation: logo-spin infinite 20s linear;\n    }\n  }\n  \n  .card {\n    padding: 2em;\n  }\n  \n  .read-the-docs {\n    color: #888;\n  }\n  \n\n/* widget */\n\n.chat-widget {\n  display: flex;\n  align-items: center;\n  background-color: #002F86;\n  color: white;\n  padding: 12px 24px;\n  border-radius:16px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);\n  font-family: 'Orbitron', sans-serif;\n  gap: 1px;\n  width: fit-content;\n}\n\n.chat-logo {\n  width: 50px;  /* Adjusted width */\n  height: 50px;  /* Adjusted height */\n  border-radius: 50%;  /* Make it a circle */\n  overflow: hidden;  /* Ensures the image is clipped to fit the circle */\n}\n\n.chat-logo-img {\n  width: 100%;  /* Make the image responsive within the container */\n  height: 100%;\n  object-fit: cover;  /* Ensures the image covers the div while maintaining aspect ratio */\n}\n\n.chat-text {\n  /* display: flex; */\n  flex-direction: column;\n  color: white !important;\n  /* text-align: left; */\n}\n.chat-text-header{\n   text-align: center !important;\n   color: white !important;\n}\n\n.chat-text p {\n  color: white !important;\n  margin: 0;\n  font-size: 12px;\n  /* font-weight: bold; */\n}\n\n.underline {\n  display: inline-block;\n  width: 80px;\n  border-bottom: 2px solid white;\n  margin-left: 5px;\n}\n\n.chat-powered {\n  font-size: 2px;\n  color: white;\n  padding-left:38px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
